import { Component } from 'preact';
import { JsonInput } from './json-input';
import { SummaryTable } from './summary-table';
import { StatsTable } from './stats-table';
import { FlameGraph } from './flamegraph';
import { FlamegraphLegend } from './flamegraph-legend'
import { hslToHex } from '../util'

export class RuleProfiler extends Component {
	state = {
		ruleData: {},
		hueMap: {},
		stats: [],
		sid: null,
		summary: null,
		queryProfile: {},
		numberFormat: null
	}

	handleJsonChange = event => {
		let data = null;
		try {
			data = JSON.parse(event.target.value);
		}
		catch (err) {
			console.error(err);
		}

		if (typeof data !== 'object' || data === null) {
			this.setState({
				ruleData: {},
				hueMap: {},
				stats: [],
				sid: null,
				summary: null,
				queryProfile: {}
			});
			return;
		}

		const { stats, ruleData, hueMap } = processRuleData(data.queryProfile);

		const summary = data.result ?
			{
				totalMs: data.stats.totalMS,
				engineTime: data.stats.approxEngineMS,
				totalConditionCount: data.stats.totalConditionCount,
				callDatasourceCount: data.stats.callDatasource.calls,
				callDatasourceTime: data.stats.callDatasource.ms
			}
			: {};

			if (Array.isArray(data.result) && data.result > 0) {
				summary.evidenceTree = `https://app.rainbird.ai/applications/components/rainbird-analysis-ui/whyAnalysis.html?id=${data.result[0].factID}?api=https://api.rainbird.ai`
			}

		this.setState({
			ruleData,
			stats: stats.sort((a, b) => b.totalTime - a.totalTime),
			sid: data.sid,
			summary,
			hueMap
		});
	}

	componentDidMount () {
		const { locales, ...options } = this.props.numberFormat;
		this.setState({
			numberFormat: new Intl.NumberFormat(locales, options)
		});
	}

	shouldComponentUpdate (_, nextState) {
		return typeof nextState.ruleData === 'object'
			&& Array.isArray(nextState.ruleData.children)
			&& nextState.ruleData.children.length > 0
			&& nextState.sid !== this.state.sid;
	}

	render () {
		return (<div>
			<div class="row">
				<div class="column">
					<JsonInput placeHolder="Paste JSON here..." handleJsonChange={this.handleJsonChange} />
				</div>
				<div class="column">
					<SummaryTable {...this.state.summary} numberFormat={this.state.numberFormat}  />
				</div>
			</div>
			<div class="row">
				<FlameGraph data={this.state.ruleData} />
			</div>
			<div class='row legend-row'>
				<div class='column'>
					<FlamegraphLegend data={this.state.hueMap} />
				</div>
			</div>
			<div class="row stats">
				<div class="column">
					<StatsTable numberFormat={this.state.numberFormat} stats={this.state.stats} />
				</div>
			</div>
		</div>);
	}
}

function processRuleData (profile) {
	const stats = [];
	const hueMap = {}
	const fallbackColour = '#b3b3b3'
	const hues = circularIterator([
		26,
		57,
		216,
		297,
		177
	])
	const ruleData = {
		children: nextChildren([], profile),
		value: computeTimeSum(0, profile)
	};

	for (const stat of stats) {
		stat.averageTime = stat.totalTime / stat.calls;
	}

	return { stats, ruleData, hueMap };

	function nextChildren (children, profile) {
		if (!profile) return;
		profile.forEach(rule => {
			recordStat(rule);
			const { relationship, ruleIndex, lineNumber, totalTime, calledRules, filename } = rule;
			const summedTime = computeTimeSum(totalTime.nanoseconds, calledRules);
			const obj = {
				name: relationship,
				value: summedTime,
				ruleIndex,
				lineNumber,
				filename,
				children: []
			};

			if (!filename) {
				obj.color = fallbackColour
			} else if (hueMap[filename]) {
				obj.color = hslToHex(...randomHsl(hueMap[filename]))
			} else {
				const hue = hues.next().value
				hueMap[filename] = hue
				obj.color =  hslToHex(...randomHsl(hue))
			}

			obj.children = nextChildren(obj.children, calledRules);
			children.push(obj);
		});
		return children;
	}
	function recordStat ({ relationship, ruleIndex, lineNumber, totalTime, callCount, filename }) {
		const stat = stats.find(stat => stat.ruleIndex === ruleIndex && stat.filename === filename);
		if (!stat) {
			stats.push({
				relationship,
				ruleIndex,
				lineNumber,
				filename,
				totalTime: totalTime.nanoseconds,
				calls: callCount
			});
		}
		else {
			stat.calls = stat.calls + callCount;
			stat.totalTime = stat.totalTime + totalTime.nanoseconds;
		}
	}
}

function computeTimeSum (ruleTime, calledRules) {
	if (calledRules.length === 0) return ruleTime;
	let sum = ruleTime;
	calledRules.forEach(calledRule => {
		sum += computeTimeSum(calledRule.totalTime.nanoseconds, calledRule.calledRules);
	});
	return sum;
}

function randomHsl (hue) {
	return [
		hue,
		100,
		randomLightness()
	]
}

function randomLightness ({ lowerBound = 35, upperBound = 65 } = {}) {
	const numberOfPossibleValues = upperBound - lowerBound + 1;
	return Math.floor(Math.random() * numberOfPossibleValues + lowerBound);
}

function circularIterator (arr) {
	let index = -1
  const elements = Array.isArray(arr) ? arr.slice() : []
	const length = elements.length

	const iterator = {
		next: () => {
			if (length) {
				index = (index + 1) % length
				return { value: elements[index], done: false }
			}
		}
	}

	return iterator
}



// WEBPACK FOOTER //
// ./components/rule-profiler.js